interface ButtonProps {
    label: string;
    styleButton?: string;
    onClick?: () => void;
    type?: "button" | "submit" | "reset" | undefined;
}

function Button({ label, styleButton, type = "button", onClick }: ButtonProps) {
    const style = `${styleButton} pointer bg-accent text-white font-medium py-[10px] px-[20px] rounded-[8px] transform transition-transform duration-300 hover:scale-105 hover:shadow-button flex justify-center items-center text-center`;
    return (
        <button type={type} className={style} onClick={onClick}>
            {label}
        </button>
    );
}

export default Button;
